export default __webpack_public_path__ + "static/instagram-icon-b2fd603463581db33ca5176de637cef5.png";